module.exports = __webpack_public_path__ + "img/as-ssc.fd157dbe.jpg";